export function buildShareParams({ categoryId, gender, systemId, sizeValue }) {
  const params = new URLSearchParams();
  if (categoryId) params.set('cat', categoryId);
  if (gender) params.set('gender', gender);
  if (systemId) params.set('sys', systemId);
  if (sizeValue) params.set('size', sizeValue);
  return params.toString();
}

export function parseShareParams(search) {
  const params = new URLSearchParams(search);
  return {
    categoryId: params.get('cat') || null,
    gender: params.get('gender') || null,
    systemId: params.get('sys') || null,
    sizeValue: params.get('size') || '',
  };
}

export function buildShareUrl(pathname, state) {
  const qs = buildShareParams(state);
  if (typeof window === 'undefined') return pathname;
  return `${window.location.origin}${pathname}?${qs}`;
}
